import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.05 5.88l-4.65 4.65-1.97-1.97-.95.95 2.92 2.92L18 6.84l-.95-.96zM3.2 6.06v4.25h4.26V6.06zm3.3 3.3H4.15V7H6.5zM3.2 11.3v4.25h4.26V11.3zm3.3 3.3H4.15v-2.35H6.5z" />
    <path d="M13.9 12.64v4.25H1.15V3.06h2.56V4.8h7.64V3.06h2.55v4.27L15 6.2V1.91h-3.7L9.44 0H5.62L3.7 1.91H0V18h15v-6.59zm-9-10.26l1.19-1.23H9l1.2 1.23v1.28H4.85z" />
  </svg>
);

export default SvgComponent;
